import { ref, toValue, watchEffect } from 'vue';

export function useSegmentTypes(query) {
  const segment_type = ref(null);
  const activity_type = ref(null);

  /**
   * Converts and formats the "type" param that the front-end uses to a format that the backend needs
   * @param {object} query - vue router query string object
   * @returns {object} types
   * @returns {string} types.segment_type
   * @returns {string} types.activity_type
   */
  function formatTypes(query = {}) {
    const defaults = ['air', 'hotel', 'car', 'rail', 'transportation', 'restaurant', 'activity'];

    let segmentTypes = query.type?.split(',') ?? defaults;
    let activityTypes = [];

    // pull out any activity types and format for the backend
    segmentTypes = segmentTypes.filter((type) => {
      if (['transportation', 'restaurant'].includes(type)) {
        activityTypes.push(type);
        return false;
      }

      if (type === 'activity') {
        activityTypes.push('general');
      }

      return true;
    });

    // Makes sure segmentTypes includes 'activity' if needed
    if (activityTypes.length && !segmentTypes.includes('activity')) {
      segmentTypes.push('activity');
    }

    return {
      segment_type: segmentTypes.join(','),
      activity_type: activityTypes.join(','),
    };
  }

  watchEffect(() => {
    const types = formatTypes(toValue(query));
    segment_type.value = types.segment_type;
    activity_type.value = types.activity_type;
  });

  return { segment_type, activity_type };
}
